export default "__VITE_ASSET__BWFMBOLB__"